import { createElementBlock as t, openBlock as l, createElementVNode as e } from "vue";
import n from "./index289.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(f, o, i, p, d, m) {
  return l(), t("svg", c, o[0] || (o[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#FFF9D5",
        d: "M42.167 18.833c6.444 6.444 6.444 16.89 0 23.334-6.443 6.444-16.89 6.444-23.334 0-6.444-6.444-6.444-16.89 0-23.334 6.444-6.444 16.891-6.444 23.334 0"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M17.949 17.949c6.844-6.844 17.887-6.93 24.837-.26l.265.26c6.844 6.844 6.93 17.886.26 24.837l-.26.265c-6.93 6.932-18.17 6.932-25.102 0-6.932-6.932-6.932-18.17 0-25.102Zm23.073 1.512c-5.972-5.699-15.436-5.614-21.305.256-5.956 5.955-5.956 15.61 0 21.566 5.955 5.956 15.612 5.956 21.566 0 5.87-5.87 5.955-15.332.255-21.305l-.255-.261-.261-.256Z"
      })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ n(r, [["render", s]]);
export {
  u as default
};
